<template>
        <div class="search_result_wrap">
            <div class="total_srch_wrap">
                <div class="total_srch_box">
                    <dl>
                        <dt>
                            <select name="dataType" v-model="myDataType">
                                <option value="all">All Fields</option>
                                <option value="title">Title</option>
                                <option value="model_name">Model</option>
                                <option value="model_title">Title+Model</option>
                                <option value="suffix_model">Suffix+Model</option>
                                <option value="contents">Contents</option>					
                            </select>
                        </dt>
                        <dd class="srch_int">
                            <input
                            type="text"
                            class="m_int"
                            v-model="mySearchWord"
                            placeholder="Suffix, Model, Keyword..."
                            title="search"
                            autocomplete="off" 
                            @keydown.down="onKeyEventActive"
                            @keydown.up="onKeyEventActive"
                            @input="getSuggestList"
                            @keyup.enter="clickSearch"
                            />
                            <ul v-if="this.suggestShow" @mouseleave="suggestShow=false" class="autocomplete-ul">
                                <li class="autocomplete-li" :class="{ 'is-active': i === arrowCounter }" @mouseover="onMouseEventActive(i)" @click="selectSuggest(term)" v-for="(term,i) in suggestList" v-bind:key="i">{{term}}</li>
                            </ul>
                        </dd>
                        <dd class="srch_bt"><a href="#" @click="clickSearch">search</a></dd>
                    </dl>
                </div>
                <!--
                <div class="total_srch_bottom">
                    <div class="t_s_switch">
                        <span class="switch_t">All version</span>
                        <button type="button" id="allVer" class="switch_btn" data-toggle="button" aria-pressed="false" @click="toggleAllVer"><span></span></button>
                    </div>
                    <div class="ad_bt_box">
                        <a href="#" class="ad_search_bt" @click="updateStatus">Advance Search</a>
                    </div>
                </div>
                -->
            </div>
            <!--
            <span class="t_s_chk_box">   
                <label>
                    <input type="checkbox" id="withinSearch" v-model="withinSearch">
                    <span>Search Within Results</span>
                </label>
            </span>
            -->  
        </div>    
</template>

<script>
import $ from "jquery";
import { getSearchSuggestList } from "@/api/search";
export default {
    props : ["adSearchStatus", "searchWord", "dataType"],
    data() {
        return {
            withinSearch : false,
            myDataType: 'suffix_model',
            allVer: false,
            mySearchWord: this.searchWord,
            suggestList : [],
            suggestShow : false,
            arrowCounter: 0 ,
        }
    },
    watch: {
        searchWord: function(val) {
            this.mySearchWord = val;
        },
        dataType: function(val) {
           this.myDataType = val;
        }
    },
    methods : {
        updateStatus() {
            this.$emit("updateStatus", !this.adSearchStatus);
        },
        clickSearch()  {
            // autocomplete 체크 및 검색
            let active = $(".is-active");
            if(active){
                let text = $(active).text();
                if(text){
                // 검색어 선택
                this.selectSuggest(text);
                }else{
                    this.$router.replace({query: {searchWord: this.mySearchWord} })
                    const formData = {
                        dataType: this.myDataType,
                        searchWord: this.mySearchWord,
                        allVer: this.allVer,
                        withinSearch: this.withinSearch
                    };
                    this.$emit("clickSearch", formData);
                }
            }else{
                this.$router.replace({query: {searchWord: this.mySearchWord} })
                const formData = {
                    dataType: this.myDataType,
                    searchWord: this.mySearchWord,
                    allVer: this.allVer,
                    withinSearch: this.withinSearch
                };
                this.$emit("clickSearch", formData);
            }
        },
        toggleAllVer() {
            if($("#allVer").hasClass("active")) {
                $("#allVer").removeClass("active");
                this.allVer = false;
            } else {
                $("#allVer").addClass("active");
                this.allVer = true;
            }
        },
        // 검색어 autocomplete 이벤트1
        async getSuggestList(){
            try {
                const resp = await getSearchSuggestList(this.mySearchWord);
                if(resp!=null && resp.data.suggestList.length>0){
                    this.suggestShow = true;
                    this.suggestList = resp.data.suggestList;
                    this.arrowCounter=-1;
                }else{
                    this.suggestShow = false;
                }
            } catch (err) {
                console.log(err);
            }
        },
        // 검색어 autocomplete 이벤트2 (키보드 동작)
        onKeyEventActive(e){
            if (this.suggestList.length > 0) {
                if(e.code=="ArrowDown"){
                ++this.arrowCounter;
                }else{
                --this.arrowCounter;
                }
                if (this.arrowCounter >= this.suggestList.length)
                this.arrowCounter = (this.arrowCounter) % this.suggestList.length;
                else if (this.arrowCounter < 0)
                this.arrowCounter = this.suggestList.length + this.arrowCounter;
            }
        },
        // 검색어 autocomplete 이벤트3 (마우스 동작)
        onMouseEventActive(index){
            $(".autocomplete-li").removeClass("is-active");
            this.arrowCounter = index;
        },
        // 검색어 autocomplete 이벤트4 (자동완성 선택)
        selectSuggest(term){
            this.mySearchWord=term;
            this.suggestShow=false;
        },
    }
}
</script>
<style scoped>
.autocomplete-ul{
    width: 410px;
    background: white;
    margin-top: 14px;
    position: absolute;
    z-index: 10;
    /* height: 200px;
    overflow: auto; */
}
.autocomplete-li{
    padding: 10px;
}

.is-active {
  background-color: #f2faff;
}

.search_result_wrap{
    overflow: inherit !important;
}


/* .autocomplete-li:hover{
    background: #f2faff;
} */
</style>